// @ts-nocheck
import { faFileExport, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import FilterButtonGroup, {
  FilterMenu
} from 'components/common/FilterButtonGroup';
import FilterTab, { FilterTabItem } from 'components/common/FilterTab';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import SearchBox from 'components/common/SearchBox';
import ProductsTable, {
  productsTablecolumns
} from 'components/tables/ProductsTable';
import { defaultBreadcrumbItems } from 'data/commonData';
import { productsTableData } from 'data/e-commerce/products';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { Col, Row } from 'react-bootstrap';
import { ChangeEvent } from 'react';
import { useEffect, useState } from 'react';
import { ToastContainer, toast, Zoom } from 'react-toastify';
import axios from 'axios';
import { getCookie, isAuth } from 'helpers/helpers';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import {
  ButtonGroup,
  Dropdown,
  Card,
  ProgressBar,
  Badge,
  Form
} from 'react-bootstrap';
import {
  faChevronRight,
  faCreditCard,
  faListCheck,
  faUser
} from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';

const tabItems: FilterTabItem[] = [
  {
    label: 'All',
    value: 'all',
    count: 68817
  },
  {
    label: 'Published',
    value: 'published',
    count: 70348
  },
  {
    label: 'Drafts',
    value: 'drafts',
    count: 17
  },
  {
    label: 'On discount',
    value: 'on_discount',
    count: 810
  }
];

const filterMenus: FilterMenu[] = [
  {
    label: 'Kategorien',
    items: [
      {
        label: 'Plants'
      },
      {
        label: 'Furniture'
      },
      {
        label: 'Fashion'
      }
    ]
  },
  {
    label: 'Vendor',
    items: [
      {
        label: 'Blue Olive Plant sellers. Inc'
      },
      {
        label: 'Beatrice Furnitures'
      },
      {
        label: 'Kizzstore'
      }
    ]
  }
];

const CSVUpload = () => {
  const token = getCookie('token');
  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    table.setGlobalFilter(e.target.value || undefined);
  };

  const uploadToServer = (file, onUploadProgress) => {
    let formData = new FormData();

    formData.append('file', file);
    if (!isAuth()) {
    } else {
      return axios.post(
        `${process.env.REACT_APP_PRODUCT_API}/post-csv-file`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`
          },
          onUploadProgress
        }
      );
    }
  };

  const [selectedFiles, setSelectedFiles] = useState(undefined);
  const [currentFile, setCurrentFile] = useState(undefined);
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState('');

  const selectFile = event => {
    setSelectedFiles(event.target.files);
  };

  const upload = () => {
    let currentFile = selectedFiles[0];

    setProgress(0);
    setCurrentFile(currentFile);

    uploadToServer(currentFile, event => {
      setProgress(Math.round((100 * event.loaded) / event.total));
    })
      .then(async response => {
        if (response.status === 200) {
          setMessage(response.data.message);
          toast.success('Upload erfolgreich', {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'dark',
            transition: Zoom
          });
        } else {
          setMessage(response.data.message);
        }
      })
      .catch(error => {
        setProgress(0);
        setMessage('CSV Import fehlgeschlagen');
        setCurrentFile(undefined);
      });

    setSelectedFiles(undefined);
  };

  const uploadToServerGTIN = (file, onUploadProgress) => {
    const token = getCookie('token');
    let formDataGTIN = new FormData();

    formDataGTIN.append('file', file);
    if (!isAuth()) {
    } else {
      return axios.post(
        `${process.env.REACT_APP_PRODUCT_API}/post-csv-file-gtin`,
        formDataGTIN,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`
          },
          onUploadProgress
        }
      );
    }
  };

  const [selectedFilesGTIN, setSelectedFilesGTIN] = useState(undefined);
  const [currentFileGTIN, setCurrentFileGTIN] = useState(undefined);
  const [progressGTIN, setProgressGTIN] = useState(0);
  const [messageGTIN, setMessageGTIN] = useState('');

  const selectFileGTIN = event => {
    setSelectedFilesGTIN(event.target.files);
  };

  const uploadGTIN = () => {
    let currentFileGTIN = selectedFilesGTIN[0];

    setProgressGTIN(0);
    setCurrentFileGTIN(currentFileGTIN);

    uploadToServerGTIN(currentFileGTIN, event => {
      setProgressGTIN(Math.round((100 * event.loaded) / event.total));
    })
      .then(async response => {
        if (response.status === 200) {
          toast.success('Upload erfolgreich', {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'dark',
            transition: Zoom
          });
          setMessageGTIN(response.data.message);
        } else {
          setMessageGTIN(response.data.message);
        }
      })
      .catch(error => {
        setProgressGTIN(0);
        setMessageGTIN('CSV Import fehlgeschlagen');
        setCurrentFileGTIN(undefined);
      });

    setSelectedFilesGTIN(undefined);
  };

  const uploadToServerDATEN = (file, onUploadProgress) => {
    const token = getCookie('token');
    let formDataDATEN = new FormData();

    formDataDATEN.append('file', file);
    if (!isAuth()) {
    } else {
      return axios.post(
        `${process.env.REACT_APP_PRODUCT_API}/post-csv-file-daten`,
        formDataDATEN,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`
          },
          onUploadProgress
        }
      );
    }
  };

  const [selectedFilesDATEN, setSelectedFilesDATEN] = useState(undefined);
  const [currentFileDATEN, setCurrentFileDATEN] = useState(undefined);
  const [progressDATEN, setProgressDATEN] = useState(0);
  const [messageDATEN, setMessageDATEN] = useState('');

  const selectFileDATEN = event => {
    setSelectedFilesDATEN(event.target.files);
  };

  const uploadDATEN = () => {
    let currentFileDATEN = selectedFilesDATEN[0];

    setProgressDATEN(0);
    setCurrentFileDATEN(currentFileDATEN);

    uploadToServerDATEN(currentFileDATEN, event => {
      setProgressDATEN(Math.round((100 * event.loaded) / event.total));
    })
      .then(async response => {
        if (response.status === 200) {
          toast.success('Upload erfolgreich', {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'dark',
            transition: Zoom
          });
          setMessageDATEN(response.data.message);
        } else {
          setMessageDATEN(response.data.message);
        }
      })
      .catch(error => {
        setProgressDATEN(0);
        setMessageDATEN('CSV Import fehlgeschlagen');
        setCurrentFileDATEN(undefined);
      });

    setSelectedFilesDATEN(undefined);
  };

  const [readyCSVDownloadLISTING, setReadyCSVDownloadLISTING] = useState(false);
  const [csvExportListingLink, setCsvExportListingLink] = useState('');

  const csvExportListingStart = () => {
    if (!isAuth()) {
    } else {
      const token = getCookie('token');
      axios({
        method: 'post',
        url: process.env.REACT_APP_PRODUCT_API + '/create-csv-export-products',
        data: {},
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then(response => {
          response &&
            response.data &&
            response.data.link &&
            setReadyCSVDownloadLISTING(true);
          response &&
            response.data &&
            response.data.link &&
            setCsvExportListingLink(
              process.env.REACT_APP_SERVER_URL + response.data.link
            );
        })
        .catch(err => {
          console.log('err', err);
        });
    }
  };

  const [readyCSVDownloadGTIN, setReadyCSVDownloadGTIN] = useState(false);
  const [csvExportGTINLink, setCsvExportGTINLink] = useState('');

  const csvExportGTINStart = () => {
    if (!isAuth()) {
    } else {
      const token = getCookie('token');
      axios({
        method: 'post',
        url: process.env.REACT_APP_PRODUCT_API + '/create-csv-export-gtin',
        data: {},
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then(response => {
          response &&
            response.data &&
            response.data.link &&
            setReadyCSVDownloadGTIN(true);
          response &&
            response.data &&
            response.data.link &&
            setCsvExportGTINLink(
              process.env.REACT_APP_SERVER_URL + response.data.link
            );
        })
        .catch(err => {
          console.log('err', err);
        });
    }
  };

  const [readyCSVDownloadDATEN, setReadyCSVDownloadDATEN] = useState(false);
  const [csvExportDATENLink, setCsvExportDATENLink] = useState('');

  const csvExportDATENStart = () => {
    if (!isAuth()) {
    } else {
      const token = getCookie('token');
      axios({
        method: 'post',
        url: process.env.REACT_APP_PRODUCT_API + '/create-csv-export-daten',
        data: {},
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then(response => {
          response &&
            response.data &&
            response.data.link &&
            setReadyCSVDownloadDATEN(true);
          response &&
            response.data &&
            response.data.link &&
            setCsvExportDATENLink(
              process.env.REACT_APP_SERVER_URL + response.data.link
            );
        })
        .catch(err => {
          console.log('err', err);
        });
    }
  };

  const disableAllLinks = () => {
    setReadyCSVDownloadLISTING(false);
    setCsvExportListingLink('');
    setReadyCSVDownloadGTIN(false);
    setCsvExportGTINLink('');
    setReadyCSVDownloadDATEN(false);
    setCsvExportDATENLink('');
  };

  const [deleteStandard, setDeleteStandard] = useState(true);
  const [deleteThree, setDeleteThree] = useState(false);
  const [deleteTwo, setDeleteTwo] = useState(false);
  const [deleteOne, setDeleteOne] = useState(false);
  const [deleteGo, setDeleteGo] = useState(false);
  const [deleteGoFinal, setDeleteGoFinal] = useState(false);
  const [password, setPassword] = useState('');

  const deleteStandardFunction = () => {
    setDeleteStandard(false);
    setDeleteThree(true);
  };

  const deleteThreeFunction = () => {
    setDeleteThree(false);
    setDeleteTwo(true);
  };

  const deleteTwoFunction = () => {
    setDeleteTwo(false);
    setDeleteOne(true);
  };

  const deleteOneFunction = () => {
    setDeleteOne(false);
    setDeleteGo(true);
  };

  const deleteEverything = () => {
    setDeleteStandard(true);
    setDeleteThree(false);
    setDeleteTwo(false);
    setDeleteOne(false);
    setDeleteGo(false);

    if (!isAuth()) {
    } else {
      const token = getCookie('token');

      axios({
        method: 'post',
        url: process.env.REACT_APP_PRODUCT_API + '/delete-everything',
        data: { password },
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then(response => {
          if (response.status == '200') {
            setPassword('');
            toast.success('Löschung erfolgreich', {
              position: 'top-center',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: 'dark',
              transition: Zoom
            });
          } else {
            setPassword('');
            toast.error('Löschung hat nicht geklappt', {
              position: 'top-center',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: 'dark',
              transition: Zoom
            });
          }
        })
        .catch(err => {
          console.log('err', err);
        });
    }
  };

  const PasswordFunction = e => {
    setPassword(e.target.value);
  };

  return (
    <div>
      <ToastContainer />

      <div className="mb-9" style={{ marginTop: '-60px' }}>
        <h2 className="mb-3">CSV Uploads</h2>
        <h5 className="mb-4" style={{ color: 'red', display: 'inline-block' }}>
          Reihenfolge befolgen!
        </h5>

        <Row>
          <Col lg="4">
            <Card className="h-100 hover-actions-trigger">
              <Card.Body>
                <div className="d-flex align-items-center text-center">
                  <h3 className="mb-2 line-clamp-1 lh-sm flex-1">
                    1. CSV-Import LISTING
                  </h3>
                </div>

                <div className="App text-center mt-2">
                  <div
                    style={{
                      display: 'inline-block'
                    }}
                  >
                    {currentFile && (
                      <div
                        className="progress mt-2 mb-3"
                        style={{ height: '20px' }}
                      >
                        <div
                          className="progress-bar progress-bar-info progress-bar-striped"
                          role="progressbar"
                          aria-valuenow={progress}
                          aria-valuemin="0"
                          aria-valuemax="100"
                          style={{ width: progress + '%' }}
                        >
                          {progress}%
                        </div>
                      </div>
                    )}

                    <label className="btn btn-default">
                      <input type="file" onChange={selectFile} />
                    </label>
                    <br />

                    <button
                      className="btn btn-success"
                      disabled={!selectedFiles}
                      onClick={upload}
                    >
                      Uploaden und Importieren
                    </button>

                    {message && (
                      <div className="alert alert-light mt-3" role="alert">
                        {message}
                      </div>
                    )}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg="4">
            <Card className="h-100 hover-actions-trigger">
              <Card.Body>
                <div className="d-flex align-items-center text-center">
                  <h3 className="mb-2 line-clamp-1 lh-sm flex-1">
                    2. CSV-Import GTIN
                  </h3>
                </div>
                <div className="App text-center mt-2">
                  <div
                    style={{
                      display: 'inline-block'
                    }}
                  >
                    {currentFileGTIN && (
                      <div
                        className="progress mt-2 mb-3"
                        style={{ height: '20px' }}
                      >
                        <div
                          className="progress-bar progress-bar-info progress-bar-striped"
                          role="progressbar"
                          aria-valuenow={progressGTIN}
                          aria-valuemin="0"
                          aria-valuemax="100"
                          style={{ width: progressGTIN + '%' }}
                        >
                          {progressGTIN}%
                        </div>
                      </div>
                    )}

                    <label className="btn btn-default">
                      <input type="file" onChange={selectFileGTIN} />
                    </label>
                    <br />

                    <button
                      className="btn btn-success"
                      disabled={!selectedFilesGTIN}
                      onClick={uploadGTIN}
                    >
                      Uploaden und Importieren
                    </button>

                    {messageGTIN && (
                      <div className="alert alert-light mt-3" role="alert">
                        {messageGTIN}
                      </div>
                    )}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg="4">
            <Card className="h-100 hover-actions-trigger">
              <Card.Body>
                <div className="d-flex align-items-center text-center">
                  <h3 className="mb-2 line-clamp-1 lh-sm flex-1">
                    3. CSV-Import DATEN
                  </h3>
                </div>
                <div className="App text-center mt-2">
                  <div
                    style={{
                      display: 'inline-block'
                    }}
                  >
                    {currentFileDATEN && (
                      <div
                        className="progress mt-2 mb-3"
                        style={{ height: '20px' }}
                      >
                        <div
                          className="progress-bar progress-bar-info progress-bar-striped"
                          role="progressbar"
                          aria-valuenow={progressDATEN}
                          aria-valuemin="0"
                          aria-valuemax="100"
                          style={{ width: progressDATEN + '%' }}
                        >
                          {progressDATEN}%
                        </div>
                      </div>
                    )}

                    <label className="btn btn-default">
                      <input type="file" onChange={selectFileDATEN} />
                    </label>
                    <br />

                    <button
                      className="btn btn-success"
                      disabled={!selectedFilesDATEN}
                      onClick={uploadDATEN}
                    >
                      Uploaden und Importieren
                    </button>

                    {messageDATEN && (
                      <div className="alert alert-light mt-3" role="alert">
                        {messageDATEN}
                      </div>
                    )}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      <div className="mb-9">
        <h2 className="mb-4">CSV Downloads</h2>
        <Row>
          <Col lg="4">
            <Card className="h-100 hover-actions-trigger">
              <Card.Body>
                <div className="d-flex align-items-center text-center">
                  <h3 className="mb-2 line-clamp-1 lh-sm flex-1">
                    CSV-Export LISTING
                  </h3>
                </div>

                <div className="App text-center mt-2">
                  <div
                    style={{
                      display: 'inline-block'
                    }}
                  >
                    <br />

                    {!readyCSVDownloadLISTING ? (
                      <button
                        className="btn btn-primary"
                        onClick={csvExportListingStart}
                      >
                        Exportieren
                      </button>
                    ) : (
                      <a
                        onClick={disableAllLinks}
                        href={csvExportListingLink}
                        target="_blank"
                      >
                        <button className="btn btn-success">Download</button>
                      </a>
                    )}

                    <br />

                    {message && (
                      <div className="alert alert-light mt-3" role="alert">
                        {message}
                      </div>
                    )}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg="4">
            <Card className="h-100 hover-actions-trigger">
              <Card.Body>
                <div className="d-flex align-items-center text-center">
                  <h3 className="mb-2 line-clamp-1 lh-sm flex-1">
                    CSV-Export GTIN
                  </h3>
                </div>

                <div className="App text-center mt-2">
                  <div
                    style={{
                      display: 'inline-block'
                    }}
                  >
                    <br />

                    {!readyCSVDownloadGTIN ? (
                      <button
                        className="btn btn-primary"
                        onClick={csvExportGTINStart}
                      >
                        Exportieren
                      </button>
                    ) : (
                      <a
                        onClick={disableAllLinks}
                        href={csvExportGTINLink}
                        target="_blank"
                      >
                        <button className="btn btn-success">Download</button>
                      </a>
                    )}

                    <br />

                    {message && (
                      <div className="alert alert-light mt-3" role="alert">
                        {message}
                      </div>
                    )}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg="4">
            <Card className="h-100 hover-actions-trigger">
              <Card.Body>
                <div className="d-flex align-items-center text-center">
                  <h3 className="mb-2 line-clamp-1 lh-sm flex-1">
                    CSV-Export DATEN
                  </h3>
                </div>

                <div className="App text-center mt-2">
                  <div
                    style={{
                      display: 'inline-block'
                    }}
                  >
                    <br />

                    {!readyCSVDownloadDATEN ? (
                      <button
                        className="btn btn-primary"
                        onClick={csvExportDATENStart}
                      >
                        Exportieren
                      </button>
                    ) : (
                      <a
                        onClick={disableAllLinks}
                        href={csvExportDATENLink}
                        target="_blank"
                      >
                        <button className="btn btn-success">Download</button>
                      </a>
                    )}

                    <br />

                    {message && (
                      <div className="alert alert-light mt-3" role="alert">
                        {message}
                      </div>
                    )}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      <div className="mb-9">
        <h2 className="mb-4">Alles löschen</h2>
        <Row>
          <Col lg="4">
            <Card className="h-100 hover-actions-trigger">
              <Card.Body>
                <div className="d-flex align-items-center text-center">
                  <h3 className="mb-2 line-clamp-1 lh-sm flex-1">
                    Alles löschen
                  </h3>
                </div>

                <div className="App text-center mt-2">
                  <div
                    style={{
                      display: 'inline-block'
                    }}
                  >
                    <br />

                    {deleteStandard ? (
                      <button
                        onClick={deleteStandardFunction}
                        className="btn btn-danger"
                      >
                        Alles löschen
                      </button>
                    ) : deleteThree ? (
                      <button
                        onClick={deleteThreeFunction}
                        className="btn btn-danger"
                      >
                        3
                      </button>
                    ) : deleteTwo ? (
                      <button
                        onClick={deleteTwoFunction}
                        className="btn btn-danger"
                      >
                        2
                      </button>
                    ) : deleteOne ? (
                      <button
                        onClick={deleteOneFunction}
                        className="btn btn-danger"
                      >
                        1
                      </button>
                    ) : (
                      deleteGo && (
                        <>
                          <button
                            className="btn btn-danger"
                            onClick={deleteEverything}
                          >
                            Alles und für immer löschen?
                          </button>
                          <br />
                          <br />
                          <Form.Label>Passwort</Form.Label>
                          <Form.Control
                            onChange={PasswordFunction}
                            type="text"
                            aria-describedby="passwordHelpBlock"
                          />
                        </>
                      )
                    )}

                    <br />

                    {message && (
                      <div className="alert alert-light mt-3" role="alert">
                        {message}
                      </div>
                    )}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default CSVUpload;
